import React from "react";
import {Box, Heading, Text} from "@chakra-ui/react";

function SectionHeading({eyebrow, title, children, align = "center", light = false, mb = {base: 10, md: 14}}) {
    const centered = align === "center";
    return (
        <Box textAlign={align} maxW={centered ? "3xl" : "none"} mx={centered ? "auto" : 0} mb={mb}>
            {eyebrow && (
                <Text textTransform="uppercase" letterSpacing="0.2em" fontSize="xs" fontWeight={700}
                      color={light ? "brand.200" : "brand.500"} mb={3}>
                    {eyebrow}
                </Text>
            )}
            <Heading as="h2" fontSize={{base: "2xl", md: "4xl"}} textTransform="uppercase" letterSpacing="0.03em"
                     lineHeight={1.15} color={light ? "white" : "ink.900"}>
                {title}
            </Heading>
            <Box w="48px" h="3px" bg="brand.500" mt={5} mx={centered ? "auto" : 0}/>
            {children && (
                <Text mt={5} fontSize={{base: "md", md: "lg"}} color={light ? "whiteAlpha.800" : "ink.500"}>
                    {children}
                </Text>
            )}
        </Box>
    );
}

export default SectionHeading;
